import { useEffect } from "react";
import { useAppDispatch } from "@/stores/hook";
import { togglePanel } from "../stores/aiChatSlice";

/**
 * Global ⌘K / Ctrl+K → toggle AI panel.
 * Skips when focus is inside a textarea/input (so users can type ⌘K-style
 * literals without it stealing the shortcut, e.g. in search fields).
 */
export function useAIHotkey() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      const isCombo = (e.metaKey || e.ctrlKey) && (e.key === "k" || e.key === "K");
      if (!isCombo) return;
      const target = e.target as HTMLElement | null;
      const tag = target?.tagName?.toLowerCase();
      const isEditable =
        tag === "input" || tag === "textarea" || target?.isContentEditable;
      // Even when in an input we still want ⌘K to open the panel — Cursor does
      // the same. Just allow the toggle and let the input stay focused.
      e.preventDefault();
      dispatch(togglePanel());
      // touch isEditable to avoid unused-var lint, kept for future refinement
      void isEditable;
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [dispatch]);
}
